export default {
  currentPlayer: '#00ba17',
  otherPlayer: (volume: number): string => `hsl(226, 93%, ${volume * 53}%)`
}
